import { Grid } from '@material-ui/core';
import Axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import ToolTip from '../../components/Tooltip/Tooltip';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import ARR from './components/ARR';
import Churn from './components/Churn';
import LTVCAC from './components/LTVCAC';
import MRR from './components/MRR';
import classes from './UnitEconomics.module.css';

/* const MRR = React.lazy(() => {
	return import('./components/MRR');
}); */

const UnitEconomics = () => {
	//Filters
	function formatDate(date) {
		var d = new Date(date),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		const dateFormat = [year, month, '01'].join('-');
		return dateFormat.toString();
	}

	const formatDateName = (dateToTransform) => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	const unitEconomicsDate = new Date();
	const date1 = formatDate(unitEconomicsDate.setMonth(unitEconomicsDate.getMonth() - 2));

	const unitEconomicsDateCompare = new Date();
	const date2 = formatDate(unitEconomicsDateCompare.setMonth(unitEconomicsDateCompare.getMonth() - 3));

	const unitEconomicsYearCompare = new Date();
	const date3 = formatDate(unitEconomicsYearCompare.setMonth(unitEconomicsYearCompare.getMonth() - 14));

	//Filters
	const [country, setCountry] = useState('Todos');
	const [clasificacion, setClasificacion] = useState('0');

	//Apis
	const [mrrMensualActualUrl, setMrrMensualActualUrl] = useState(`/getMrrPlanMensual?dateFrom=${date1}`);
	const [mrrAnualActualUrl, setMrrAnualActualUrl] = useState(`/getMrrPlanAnual?dateFrom=${date1}`);
	const [mrrMensualAnteriorUrl, setMrrMensualAnteriorUrl] = useState(`/getMrrPlanMensual?dateFrom=${date2}`);
	const [mrrAnualAnteriorUrl, setMrrAnualAnteriorUrl] = useState(`/getMrrPlanAnual?dateFrom=${date2}`);
	const [churnUrl, setChurnUrl] = useState(`/getVentasAnualCompare?dateFrom=${date1}&dateTo=${date3}`);
	//Data

	const [mrrMensualActual, setDataMrrMensualActual] = useState([]);
	const [mrrAnualActual, setDataMrrAnualActual] = useState([]);
	const [mrrMensualAnterior, setDataMrrMensualAnterior] = useState([]);
	const [mrrAnualAnterior, setDataMrrAnualAnterior] = useState([]);
	const [churn, setDataChurn] = useState([]);
	//const [freeTrials, setDataFreeTrials] = useState([]);

	//Aux
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);
	const [booleanClasificacion, setBooleanClasificacion] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			setIsError(false);
			setIsLoading(true);

			Axios.all([
				Axios.get(mrrMensualActualUrl),
				Axios.get(mrrAnualActualUrl),
				Axios.get(mrrMensualAnteriorUrl),
				Axios.get(mrrAnualAnteriorUrl),
				Axios.get(churnUrl),
			]).then(
				Axios.spread((obj1, obj2, obj3, obj4, obj5) => {
					try {
						setDataMrrMensualActual(obj1.data);
						setDataMrrAnualActual(obj2.data);
						setDataMrrMensualAnterior(obj3.data);
						setDataMrrAnualAnterior(obj4.data);
						setDataChurn(obj5.data);
					} catch (error) {
						setIsError(true);
					}
					setIsLoading(false);
				}),
			);
		};
		fetchData();
	}, [mrrMensualActualUrl, mrrAnualActualUrl, mrrMensualAnteriorUrl, mrrAnualAnteriorUrl, churnUrl]);

	return (
		<Fragment>
			<div className={classes.cardFilter}>
				<Grid container direction="row" justify="center" alignItems="center">
					<div className={classes.formup}>
						<form
							onSubmit={(event) => {
								setMrrMensualActualUrl(`/getMrrPlanMensual?dateFrom=${date1}&pais=${country}&clasificacion=${clasificacion}`);
								setMrrAnualActualUrl(`/getMrrPlanAnual?dateFrom=${date1}&pais=${country}&clasificacion=${clasificacion}`);
								setMrrMensualAnteriorUrl(`/getMrrPlanMensual?dateFrom=${date2}&pais=${country}&clasificacion=${clasificacion}`);
								setMrrAnualAnteriorUrl(`/getMrrPlanAnual?dateFrom=${date2}&pais=${country}&clasificacion=${clasificacion}`);
								setChurnUrl(
									`/getVentasAnualCompare?dateFrom=${date1}&dateTo=${date3}&pais=${country}&clasificacion=${clasificacion}`,
								);
								if (clasificacion !== '0') {
									setBooleanClasificacion(true);
								} else {
									setBooleanClasificacion(false);
								}
								//setIsLoading(true);
								event.preventDefault();
							}}
						>
							<Grid container spacing={2}>
								<div>
									<select value={country} onChange={(event) => setCountry(event.target.value)}>
										<option value={'Todos'}>Todos los Países</option>
										<option value={'Chile'}>Chile</option>
										<option value={'Peru'}>Peru</option>
										<option value={'Argentina'}>Argentina</option>
									</select>
								</div>
								<div>
									<select value={clasificacion} onChange={(event) => setClasificacion(event.target.value)}>
										<option value={'0'}>Pyme y Corp</option>
										<option value={'1'}>Pyme</option>
										<option value={'2'}>Corp</option>
									</select>
								</div>

								<div>
									<input className={classes.buttonRindegastos} type="submit" value="Filtrar" />
								</div>
								{isError && <div>Ups! Algo salió mal...</div>}
							</Grid>
						</form>
					</div>
				</Grid>
			</div>
			<div>
				<br></br>
			</div>

			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.cardTitle}>
							<div>Información a {formatDateName(date1)}</div>
						</div>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={4}>
						<div className={classes.card}>
							<ToolTip
								text={
									'El MRR (Monthly Recurring Revenue) está calculado con los ingresos de los Planes Mensuales y el ingreso de los Planes Anuales'
								}
							/>
							<MRR
								mrrMensual={mrrMensualActual}
								mrrAnual={mrrAnualActual}
								mrrMensualAnterior={mrrMensualAnterior}
								mrrAnualAnterior={mrrAnualAnterior}
								isLoading={isLoading}
								clasificacion={booleanClasificacion}
							/>
						</div>
					</Grid>
					<Grid item xs={4}>
						<div className={classes.card}>
							<ToolTip
								text={
									'Los ingresos recurrentes anuales (ARR) son una métrica que muestra la cantidad de ingresos recurrentes que puedes esperar según las suscripciones anuales. Representa la visión anual de los ingresos recurrentes mensuales (MRR).'
								}
							/>

							<ARR
								mrrMensual={mrrMensualActual}
								mrrAnual={mrrAnualActual}
								mrrMensualAnterior={mrrMensualAnterior}
								mrrAnualAnterior={mrrAnualAnterior}
								isLoading={isLoading}
							/>
						</div>
					</Grid>
					<Grid item xs={4}>
						<div className={classes.card}>
							<ToolTip text={'NRR'} />
						</div>
					</Grid>
				</Grid>
			</Grid>

			<Churn churn={churn} isLoading={isLoading} clasificacion={booleanClasificacion} />

			<LTVCAC
				churn={churn}
				mrrMensual={mrrMensualActual}
				mrrAnual={mrrAnualActual}
				isLoading={isLoading}
				clasificacion={booleanClasificacion}
			/>
		</Fragment>
	);
};

export default React.memo(withErrorHandler(UnitEconomics, Axios));
